import { Controller } from "@hotwired/stimulus"

// LE DÉMONSTRATEUR D'HABILLAGES — voir ThemeShowcaseBlock et _theme_showcase_block.html.erb.
//
// CE CONTRÔLEUR NE FABRIQUE RIEN. Tous les échantillons sont rendus par le serveur, chacun peint
// par les variables posées sur son panneau ; il ne fait que montrer l'un et cacher les autres.
// C'est ce qui rend la bascule instantanée, et ce qui laisse le premier échantillon lisible quand
// le JavaScript ne se charge pas.
//
// L'ÉTAT VIT DANS LE DOM et non dans une propriété : `aria-selected` et `hidden` sont déjà la
// source de vérité pour le navigateur et pour les technologies d'assistance. Un index gardé à côté
// aurait fait deux vérités, dont une seule serait annoncée à l'utilisateur.
export default class extends Controller {
  static targets = ["tab", "panel"]

  select(event) {
    this.#show(event.currentTarget.dataset.themeKey)
  }

  // LES FLÈCHES PARCOURENT LA RANGÉE, comme dans tout groupe d'onglets : c'est ce que le motif
  // `tablist` promet à qui navigue au clavier. Sans cela, la tabulation traverserait les cinq
  // onglets un par un avant d'atteindre l'échantillon.
  navigate(event) {
    const pas = { ArrowRight: 1, ArrowLeft: -1, ArrowDown: 1, ArrowUp: -1 }[event.key]
    if (!pas) return

    event.preventDefault()
    const onglets = this.tabTargets
    const courant = onglets.findIndex((tab) => tab.getAttribute("aria-selected") === "true")
    const suivant = onglets[(courant + pas + onglets.length) % onglets.length]

    this.#show(suivant.dataset.themeKey)
    suivant.focus()
  }

  #show(key) {
    if (!key) return

    this.tabTargets.forEach((tab) => {
      tab.setAttribute("aria-selected", String(tab.dataset.themeKey === key))
    })
    this.panelTargets.forEach((panel) => {
      panel.hidden = panel.dataset.themeKey !== key
    })
  }
}
